module.exports = __webpack_public_path__ + "img/a1.508c6590.jpg";